import resizeImages from '../../../plugins/resizeImages/js/resizeImages';

(function () {
    let topContent = {
        selectors: {
            abstractPreviewZoom: '.abstract-preview__zoom',
        },

        elements: {
            targets: null,
            topContentEl: null,
            abstractPreviewZoom: null,
        },

        paneId: null,

        init: function () {
            topContent.elements.abstractPreviewZoom = UX.utils.convertToArray(
                document.querySelectorAll(topContent.selectors.abstractPreviewZoom)
            );
            topContent.control();
        },

        control: function () {
            resizeImages('.top-content .abstract-preview');

            if (UX.fancybox) {
                UX.fancybox(topContent.elements.abstractPreviewZoom);
                document.addEventListener('keydown', UX.fancyboxClose);
            }

            $('.tab__nav a').on('click', function () {
                topContent.paneId = $(this).attr('href');
                setTimeout(function () {
                    UX.resizeImages(topContent.paneId + ' .top-content .abstract-preview');
                }, 100);
            });

            if ($('.top-content').length) {
                topContent.elements.targets = $('.top-content').closest('.tab').find('.tab__nav a');

                topContent.elements.targets.on('click', function () {
                    var tabActivePane = $(this).data('simple-tab-id'),
                        href = window.location.href,
                        removeParam = UX.utils.removeUrlParam('tabActivePane', href),
                        newHref,
                        hrefParams;

                    if (removeParam.indexOf('?') > -1) {
                        hrefParams = removeParam.substr(removeParam.indexOf('?') + 1).split('&');
                        if (hrefParams.length > 0) {
                            if (hrefParams.length === 1 && hrefParams[0] === '') {
                                newHref = removeParam + 'tabActivePane=' + tabActivePane;
                            } else {
                                newHref = removeParam + '&tabActivePane=' + tabActivePane;
                            }
                        }
                    } else {
                        newHref = removeParam + '?tabActivePane=' + tabActivePane;
                    }
                    history.pushState(null, null, newHref);
                });
            }
        },
    };

    UX.topContent = topContent;
})();
